import type { ApiSentryErrorContext } from '@common/api/sentryReporter';

export const SENTRY_FAILED_REQUEST_STATUS_CODES: Array<number | [number, number]> = [[500, 599]];

const toStatusNumber = (value: number | string | undefined): number | null => {
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === 'string' && value.trim()) {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
    }
    return null;
};

const isClientError = (value: number | null): boolean => (
    value != null && value >= 400 && value < 500
);

export const shouldReportApiErrorToSentry = (context: ApiSentryErrorContext): boolean => {
    const status = toStatusNumber(context.status);
    const code = toStatusNumber(context.code);

    if (context.kind === 'business' && isClientError(code ?? status)) {
        return false;
    }

    return true;
};
